/**
 * @fileoverview PATCH handler for the "/:app_group_id/canvas/:workflow_id/step/:step_id/name" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../../../../reactQueryFetcherAdapters";
import { appGroupIdCanvasWorkflowIdStepStepIdNameCacheKeys } from "./constants";
import type { PatchAppGroupIdCanvasWorkflowIdStepStepIdNameProps, PatchCanvasStepNameResult } from "./types";

export const patchCanvasStepName = reactQueryMutationAdapter(
  appGroupIdCanvasWorkflowIdStepStepIdNameCacheKeys,
  ({
    appGroupId,
    workflowId,
    stepId,
    name,
  }: PatchAppGroupIdCanvasWorkflowIdStepStepIdNameProps): Promise<PatchCanvasStepNameResult> => {
    return fetch(
      `/${appGroupId}/canvas/${workflowId}/step/${stepId}/name`,
      "PATCH",
      {
        step_name: name,
      },
      undefined,
      {
        // don't display a modal on fetch errors
        propagateFetchRequestError: false,
      }
    );
  }
);
